import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
    selector: '[roof-type-6]',
    templateUrl: './roof-type-6.component.html',
    styleUrl: './roof-type-6.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoofType6Component {
}
